export default "__VITE_ASSET__CQCUaBzB__"